import { useIntl } from "react-intl";

import BannerAlert, { BannerProps } from "@/components/wpl/banner-alert/src";
import { useLocalizedHref } from "@/libraries/web-framework";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

export const JPDBanner = () => {
    const intl = useIntl();

    const gwp6473JpdPremiumBanner = checkFeatureFlagGate(
        featureFlags.gwp6473JpdPremiumBanner
    );

    const jpdBannerMessages: BannerProps = {
        identifier: "JPDPageTemplate.premium-announcement",
        text: intl.formatMessage({
            id: "JPDPageTemplate.banner-alert.premium-announcement",
            defaultMessage:
                "Jira Product Discovery Premium is now available! Get more visibility, control, and support to build products at scale."
        }),
        linkText: intl.formatMessage({
            id: "JPDPageTemplate.link-text",
            defaultMessage: "Learn more →"
        }),
        linkUrl: useLocalizedHref("/software/jira/product-discovery/premium"),
        dataEventProps: {
            "data-product-key": "confluence",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Learn more",
            "data-label-english": "Learn more",
            "data-track-event": "jpdPageTemplate.announcementBanner.learnMore"
        }
    };

    return gwp6473JpdPremiumBanner ? (
        <BannerAlert {...jpdBannerMessages} />
    ) : null;
};
